<template>
     <v-dialog v-model="dialog" width="500">
      <v-card>
        <v-card-title class="headline">
          {{ $t('Settings.UserProfile.ResetPasswordEmail') }}
        </v-card-title>

        <v-card-text v-show="!isReset">
          {{ $t('Settings.UserProfile.SendEmailToResetPasswordText') }}
        </v-card-text>

        <v-card-text v-show="isReset">
          {{ $t('Settings.UserProfile.PasswordResetEmailHasBeenSent') }}
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn v-show="!isReset" :loading="isResetting" color="primary" text @click="resetPassword">
            {{ $t('Settings.UserProfile.ResetPassword') }}
          </v-btn>

          <v-btn v-show="isReset" color="primary" text @click="close">
            {{ $t('GeneralTranslations.Ok') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </template>
  
<script>
import { getRegionName } from "@/utils/functionsRegion";
import firebase from "firebase/app";
export default {
  data() {
    return {
      user: null,
      dialog: false,
      isReset: false,
      isResetting: false
    };
  },
  methods: {
    open(user) {
      if(!user) return

      this.dialog = true
      this.user = user
    },
    close() {
      this.dialog = false;
      this.isReset = false;
      this.isResetting = false;
    },
    resetPassword() {
      this.isResetting = true;
      firebase.app().functions(getRegionName()).httpsCallable("resetUserPassword")({
        userId: this.user.id
      }).then(() => {
        this.isReset = true;
        console.log("Password reset email sent to user: ", this.user.id);
      }).catch((error) => {
        console.error(error);
        this.$toast.open({ message: this.$t("GeneralTranslations.UnhandledError"), type: 'error' })
      }).finally(() => {
        this.isResetting = false;
      });
    },
  },
}
</script>
  
<style scoped>
.v-divider{
  padding-bottom: 0px !important;
  margin-bottom: 0px !important;
}
</style>
  